import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icons } from './Icons';
import NilVisionLogo from './NilVisionLogo';
import UserAvatar from './UserAvatar';

const BRAND   = '#5A38FD';
const BRAND_L = '#a78bfa';
const HINT_KEY = 'nv_menu_hint_seen';

export default function MobileTopBar({ profile, onNavigate, onMenuOpen, unreadCount, onNotifOpen }) {
  const [showHint, setShowHint] = useState(() => localStorage.getItem(HINT_KEY) !== 'true');

  const dismissHint = () => {
    setShowHint(false);
    localStorage.setItem(HINT_KEY, 'true');
  };

  useEffect(() => {
    if (!showHint) return;
    const t = setTimeout(dismissHint, 4000);
    return () => clearTimeout(t);
  }, [showHint]);

  const handleMenuOpen = () => { dismissHint(); onMenuOpen(); };

  return (
    <>
      <style>{`
        .nv-topbar { display: flex; }
        @media (min-width: 768px) { .nv-topbar { display: none; } }
        @keyframes hintPop { from { opacity: 0; transform: translateY(-6px) scale(0.95); } to { opacity: 1; transform: translateY(0) scale(1); } }
      `}</style>

      <header className="nv-topbar" style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 54, zIndex: 40,
        alignItems: 'center', justifyContent: 'space-between',
        padding: '0 12px 0 10px',
        paddingTop: 'env(safe-area-inset-top, 0px)',
        background: 'rgba(8,8,13,0.92)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        {/* Hamburger + logo */}
        <button onClick={handleMenuOpen}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 6px 4px 2px', display: 'flex', alignItems: 'center', gap: 10, position: 'relative' }}
          aria-label="Open navigation menu">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4.5, justifyContent: 'center', width: 20 }}>
            <span style={{ display: 'block', height: 2, borderRadius: 2, background: 'rgba(255,255,255,0.8)' }} />
            <span style={{ display: 'block', height: 2, borderRadius: 2, background: 'rgba(255,255,255,0.8)', width: '75%' }} />
            <span style={{ display: 'block', height: 2, borderRadius: 2, background: 'rgba(255,255,255,0.8)' }} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <NilVisionLogo size={24} showWordmark={false} />
            <span style={{
              fontSize: '0.78rem', fontWeight: 800, letterSpacing: '0.1em',
              background: 'linear-gradient(135deg, #fff 0%, #c4b5fd 55%, #93c5fd 100%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
            }}>NILVISION</span>
          </div>

          <AnimatePresence>
            {showHint && (
              <motion.div initial={{ opacity: 0, y: -6, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -6, scale: 0.95 }}
                transition={{ duration: 0.25, ease: [0.34, 1.56, 0.64, 1] }}
                style={{
                  position: 'absolute', top: 'calc(100% + 12px)', left: 0,
                  background: `linear-gradient(135deg, ${BRAND}, #7F00FF)`,
                  color: '#fff', fontSize: '0.72rem', fontWeight: 600,
                  padding: '6px 12px', borderRadius: 8,
                  whiteSpace: 'nowrap', pointerEvents: 'none',
                  boxShadow: '0 4px 20px rgba(90,56,253,0.5)', zIndex: 999,
                }}>
                <span style={{ position: 'absolute', top: -5, left: 14, width: 10, height: 10, background: BRAND, transform: 'rotate(45deg)', borderRadius: 2 }} />
                {'Tap here to navigate'}
              </motion.div>
            )}
          </AnimatePresence>
        </button>

        {/* Right actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <motion.button whileTap={{ scale: 0.9 }} onClick={onNotifOpen}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            aria-label="Notifications">
            <Icons.Bell style={{ width: 20, height: 20, color: 'rgba(255,255,255,0.6)' }} />
            {unreadCount > 0 && (
              <div style={{
                position: 'absolute', top: 4, right: 4,
                minWidth: 14, height: 14, borderRadius: 7,
                background: BRAND, border: '2px solid #08080D',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 8, fontWeight: 700, color: '#fff', padding: '0 2px',
                boxShadow: '0 0 8px rgba(90,56,253,0.7)',
              }}>
                {unreadCount > 9 ? '9+' : unreadCount}
              </div>
            )}
          </motion.button>

          <motion.button whileTap={{ scale: 0.9 }}
            onClick={() => onNavigate('profile')}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}>
            <UserAvatar profile={profile} size={30} style={{ border: `2px solid rgba(90,56,253,0.35)` }} />
          </motion.button>
        </div>
      </header>
    </>
  );
}
